import React from "react";

const Time = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M12 10v4h4" />
      <circle cx={12} cy={14} r={9} />
      <path d="M9 1h6M12 1v1" />
    </g>
  </svg>
);

export default Time;



// WEBPACK FOOTER //
// ./src/theme/icons/Time.js